export const SITE_SCOPE_STORAGE_KEY = "wilma:siteScope";

export interface ISiteScopedItem {
  id: string;
  siteId?: string | null;
}

/**
 * A remembered or preferred site is only usable if it still exists; anything else (deleted site,
 * stale storage) collapses to "any site" rather than hiding every location.
 */
export function resolveSiteScope(siteId: string | null | undefined, siteIds: string[]): string {
  if (!siteId) return "";
  return siteIds.includes(siteId) ? siteId : "";
}

/**
 * Narrow a location list to one site. The item currently selected (`keepId`) is always kept so a
 * picker can still display a location that is at another depot.
 */
export function scopeLocationsToSite<T extends ISiteScopedItem>(
  items: T[],
  siteId: string,
  keepId?: string | null
): T[] {
  if (!siteId) return items;
  return items.filter((item) => item.siteId === siteId || (!!keepId && item.id === keepId));
}

export function readRememberedSiteScope(): string {
  try {
    return localStorage.getItem(SITE_SCOPE_STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
}

export function rememberSiteScope(siteId: string): void {
  try {
    if (siteId) localStorage.setItem(SITE_SCOPE_STORAGE_KEY, siteId);
    else localStorage.removeItem(SITE_SCOPE_STORAGE_KEY);
  } catch {
    // Storage failures just mean the choice isn't remembered across pages.
  }
}
